import { motion } from "framer-motion";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1765758014805-a7a6cc272982?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxibGFjayUyMGFuZCUyMHdoaXRlJTIwY3JlYXRpdmUlMjBzdHVkaW8lMjB3b3Jrc3BhY2V8ZW58MHx8fHwxNzc5ODI5MTUzfDA&ixlib=rb-4.1.0&q=85";

const stats = [
  { k: "2025", v: "Inception" },
  { k: "08", v: "Focus verticals" },
  { k: "100%", v: "Fashion-native" },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-black text-white py-28 md:py-44"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-14">
        <div className="grid grid-cols-12 gap-y-16 md:gap-x-16">
          {/* Sticky label column */}
          <div className="col-span-12 md:col-span-3 lg:col-span-3">
            <div className="md:sticky md:top-32">
              <p className="text-xs uppercase tracking-[0.3em] text-white/50 mb-6">
                §01 — About
              </p>
              <div className="h-px w-12 bg-white/30" />
              <p className="mt-6 text-sm text-white/50 font-light max-w-[18ch]">
                A venture studio built by operators of the fashion industry.
              </p>
            </div>
          </div>

          {/* Editorial body */}
          <div className="col-span-12 md:col-span-9 lg:col-span-9">
            <motion.h2
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
              className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-white max-w-[24ch]"
            >
              We build, back, and scale companies engineering the
              <span className="italic font-light"> next era </span>
              of fashion.
            </motion.h2>

            <div className="mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16">
              <motion.div
                initial={{ y: 20, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.1 }}
                className="overflow-hidden"
              >
                <img
                  src={ABOUT_IMG}
                  alt="Editorial creative studio workspace"
                  className="w-full h-[420px] md:h-[520px] object-cover grayscale hover:scale-[1.03] transition-transform duration-[1200ms] ease-out"
                  loading="lazy"
                />
              </motion.div>

              <div className="flex flex-col justify-between gap-10">
                <motion.div
                  initial={{ y: 20, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.7, delay: 0.2 }}
                  className="space-y-6 text-white/70 text-base md:text-lg font-light leading-relaxed"
                >
                  <p>
                    Runway Foundry was created after years of operating within
                    the fashion ecosystem through <span className="text-white">SFWRUNWAY</span>,
                    where we gained firsthand insight into the structural
                    inefficiencies limiting emerging brands and creative
                    entrepreneurs.
                  </p>
                  <p>
                    Today, we build and support scalable businesses addressing
                    the future of commerce, sustainability, creator
                    infrastructure, and technology within fashion.
                  </p>
                </motion.div>

                <div className="grid grid-cols-3 gap-6 border-t border-white/10 pt-8">
                  {stats.map((s) => (
                    <div key={s.k} data-testid={`about-stat-${s.k}`}>
                      <div className="font-serif text-3xl md:text-4xl text-white">{s.k}</div>
                      <div className="mt-2 text-[10px] uppercase tracking-[0.25em] text-white/45">
                        {s.v}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
